import { gql } from "@apollo/client";

export const classroomTypesQuery = gql`
  query classroomTypes($scenarioId: ID!, $filter: ClassroomTypeFilterInput) {
    data(scenarioId: $scenarioId) {
      classroomTypes(filter: $filter) {
        items {
          id
          code
          name
        }
      }
    }
  }
`;
